export default __webpack_public_path__ + "static/media/flipkart.6152a809.png";